export class FontSize {
  public id: number;
  public value: number;
  public unit_id: number;
  public uid: number;

  constructor(id: number, value: number, unit_id: number, uid: number) {
    this.id = id;
    this.value = value;
    this.unit_id = unit_id;
    this.uid = uid;
  }
}
